import { format } from "date-fns";
import {
  AGE_RANGE_PLACEHOLDER,
  BEHAVIORS_PLACEHOLDER,
  BUDGET_PLACEHOLDER,
  BUSINESS_NAME_PLACEHOLDER,
  CALL_TO_ACTION_PLACEHOLDER,
  CALL_TO_ACTIONS_PLACEHOLDER,
  CALLOUTS_PLACEHOLDER,
  CHOOSE_AN_ADDRESS_PLACEHOLDER,
  COMPANIES_PLACEHOLDER,
  COMPANY_SIZES_PLACEHOLDER,
  CONVERSION_ACTIONS_PLACEHOLDER,
  CUSTOM_AUDIENCES_PLACEHOLDER,
  DEEP_LINK_PLACEHOLDER,
  DEGREES_PLACEHOLDER,
  DEMOGRAPHICS_PLACEHOLDER,
  DESCRIPTIONS,
  DESTINATION_URL_PLACEHOLDER,
  END_DATE_PLACEHOLDER,
  EXCLUDED_CUSTOM_AUDIENCES_PLACEHOLDER,
  FEMALES,
  FIELDS_OF_STUDY_PLACEHOLDER,
  GENDERS_PLACEHOLDER,
  HEADLINES,
  IMAGES_OF_CAMPAIGN_PLACEHOLDER,
  INDUSTRIES_PLACEHOLDER,
  INSTANT_EXPERIENCE_PLACEHOLDER,
  INSTANT_FORM_PLACEHOLDER,
  INTERESTS_PLACEHOLDER,
  IS_ADVANTAGE_AUDIENCE_ACTIVE_PLACEHOLDER,
  JOB_FUNCTIONS_PLACEHOLDER,
  JOB_TITLES_PLACEHOLDER,
  KEYWORDS_NEGATIVE_PLACEHOLDER,
  KEYWORDS_PLACEHOLDER,
  LANGUAGES_PLACEHOLDER,
  LOCATIONS_PLACEHOLDER,
  EXCLUDED_LOCATIONS_PLACEHOLDER,
  LOGO_URLS_PLACEHOLDER,
  LONG_HEADLINES,
  MALES,
  MEDIA_URLS_PLACEHOLDER,
  MEMBER_BEHAVIORS_PLACEHOLDER,
  OFFLINE_EVENTS_PLACEHOLDER,
  PLACEMENTS_PLACEHOLDER,
  SCHOOLS_PLACEHOLDER,
  SEARCH_THEMES_PLACEHOLDER,
  SENIORITIES_PLACEHOLDER,
  SITE_LINKS_PLACEHOLDER,
  SKILLS_PLACEHOLDER,
  START_DATE_PLACEHOLDER,
  STATUS_ACTIVE,
  STATUS_DEACTIVATED,
  STATUS_FINISHED,
  STATUS_PLACEHOLDER,
  TARGET_CPA_PLACEHOLDER,
  TITLES,
  UTM_PARAMETERS_PLACEHOLDER,
  VIDEOS_OF_CAMPAIGN_PLACEHOLDER,
  ADS_SCHEDULE_PLACEHOLDER,
  ALL_PRODUCTS,
  ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_PLACEHOLDER,
  ADS_CAMPAIGN_PRODUCTS_CONFIGURATION_SUB_TITLE,
  PRODUCT_SET_AUDIENCE_BUILDER_TITLE,
  ADS_CAMPAIGN_AD_APP_CONFIGURATION_SUB_TITLE,
  BIDDING_STRATEGY_TYPE_PLACEHOLDER,
  WELCOME_MESSAGE_TEMPLATE_PLACEHOLDER,
  CLICKS,
  MAXIMIZE_CONVERSIONS,
  MAXIMIZE_CONVERSION_VALUE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_TITLE,
  MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_TITLE,
  ADVANTAGE_CREATIVE_ENHANCES_PLACEHOLDER,
} from "../../../../../i18n/keysTranslations";
import {
  ADS_CAMPAIGN_STATUS_ACTIVE,
  ADS_CAMPAIGN_STATUS_DEACTIVATED,
  ADS_CAMPAIGN_STATUS_FINISHED,
} from "../../../../../utils/constants";
import { parseUtmString } from "../../../../../components/Common/Utms/utils/utmParameters";
import i18next from "i18next";
import { formatPlacementsForLog } from "../../../../../utils/catalogs/metaPlacements";
import { SUBDIVISION_OPTIONS_GOOGLE } from "../../../../../services/google";

const formatNumberForLog = (num) => {
  const n = Number(num);
  if (isNaN(n) || !isFinite(n)) return String(num ?? "");
  return n.toLocaleString(i18next.language || "es", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  });
};

const STATUS_TRANSLATIONS = {
  [ADS_CAMPAIGN_STATUS_DEACTIVATED]: STATUS_DEACTIVATED,
  [ADS_CAMPAIGN_STATUS_ACTIVE]: STATUS_ACTIVE,
  [ADS_CAMPAIGN_STATUS_FINISHED]: STATUS_FINISHED,
};

const GOOGLE_BIDDING_STRATEGY_LABELS = {
  TARGET_SPEND: CLICKS,
  MAXIMIZE_CONVERSIONS: MAXIMIZE_CONVERSIONS,
  MAXIMIZE_CONVERSION_VALUE: MAXIMIZE_CONVERSION_VALUE,
  TARGET_CPA: TARGET_CPA_PLACEHOLDER,
};

const ADVANTAGE_ENHANCES_ID_TO_LABEL = {
  autoCrop: MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_TITLE,
  textOptimizations:
    MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_TITLE,
  inlineComment: MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_TITLE,
  imageTemplates: MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_TITLE,
  enhanceCta: MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_TITLE,
  standardEnhances: MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_TITLE,
  imageAnimation: MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_TITLE,
  cvTransformation: MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_TITLE,
  imageBrightnessAndContrast:
    MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_TITLE,
  videoFiltering: MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_TITLE,
  descriptionAutomation:
    MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_TITLE,
  profileCard: MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_TITLE,
  carouselToVideo: MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_TITLE,
  mediaOrder: MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_TITLE,
};

const FIELD_LABEL_KEYS = {
  budget: BUDGET_PLACEHOLDER,
  locations: LOCATIONS_PLACEHOLDER,
  excludedLocations: EXCLUDED_LOCATIONS_PLACEHOLDER,
  businessName: BUSINESS_NAME_PLACEHOLDER,
  siteLinks: SITE_LINKS_PLACEHOLDER,
  callOuts: CALLOUTS_PLACEHOLDER,
  endDate: END_DATE_PLACEHOLDER,
  logoUrl: LOGO_URLS_PLACEHOLDER,
  imageUrls: IMAGES_OF_CAMPAIGN_PLACEHOLDER,
  status: STATUS_PLACEHOLDER,
  ageRange: AGE_RANGE_PLACEHOLDER,
  genders: GENDERS_PLACEHOLDER,
  interests: INTERESTS_PLACEHOLDER,
  behaviors: BEHAVIORS_PLACEHOLDER,
  demographics: DEMOGRAPHICS_PLACEHOLDER,
  customAudiences: CUSTOM_AUDIENCES_PLACEHOLDER,
  excludedCustomAudiences: EXCLUDED_CUSTOM_AUDIENCES_PLACEHOLDER,
  keywords: KEYWORDS_PLACEHOLDER,
  keywordsNegative: KEYWORDS_NEGATIVE_PLACEHOLDER,
  callToAction: CALL_TO_ACTION_PLACEHOLDER,
  destinationUrls: DESTINATION_URL_PLACEHOLDER,
  titles: TITLES,
  descriptions: DESCRIPTIONS,
  headlines: HEADLINES,
  mediaUrls: MEDIA_URLS_PLACEHOLDER,
  destinationUrl: DESTINATION_URL_PLACEHOLDER,
  logoUrls: LOGO_URLS_PLACEHOLDER,
  videoUrls: VIDEOS_OF_CAMPAIGN_PLACEHOLDER,
  longHeadlines: LONG_HEADLINES,
  searchThemes: SEARCH_THEMES_PLACEHOLDER,

  specialAdCategories: ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_PLACEHOLDER,
  schedule: ADS_SCHEDULE_PLACEHOLDER,
  productSetAudience: PRODUCT_SET_AUDIENCE_BUILDER_TITLE,
  placements: PLACEMENTS_PLACEHOLDER,
  bidGoal: TARGET_CPA_PLACEHOLDER,
  languages: LANGUAGES_PLACEHOLDER,
  estimationID: "estimationID",
  minBudget: BUDGET_PLACEHOLDER,
  maxBudget: BUDGET_PLACEHOLDER,
  isAdvantageAudienceActive: IS_ADVANTAGE_AUDIENCE_ACTIVE_PLACEHOLDER,
  advantageEnhances: ADVANTAGE_CREATIVE_ENHANCES_PLACEHOLDER,
  appConfiguration: ADS_CAMPAIGN_AD_APP_CONFIGURATION_SUB_TITLE,
  instantExperience: INSTANT_EXPERIENCE_PLACEHOLDER,
  appProductPageID: "appProductPageID",
  utmParameters: UTM_PARAMETERS_PLACEHOLDER,
  destinationFallBack: DESTINATION_URL_PLACEHOLDER,
  trackingID: "trackingID",
  trackingOfflineID: "trackingOfflineID",
  address: CHOOSE_AN_ADDRESS_PLACEHOLDER,
  messageTemplate: WELCOME_MESSAGE_TEMPLATE_PLACEHOLDER,
  startDate: START_DATE_PLACEHOLDER,
  mediaData: MEDIA_URLS_PLACEHOLDER,
  callToActions: CALL_TO_ACTIONS_PLACEHOLDER,
  instantForm: INSTANT_FORM_PLACEHOLDER,
  biddingStrategy: BIDDING_STRATEGY_TYPE_PLACEHOLDER,
  productsConfiguration: ADS_CAMPAIGN_PRODUCTS_CONFIGURATION_SUB_TITLE,
  offlineEvents: OFFLINE_EVENTS_PLACEHOLDER,
  deepLink: DEEP_LINK_PLACEHOLDER,
  musicUrl: "musicUrl",
  targetCPA: TARGET_CPA_PLACEHOLDER,
  conversionActions: CONVERSION_ACTIONS_PLACEHOLDER,
  leadForm: INSTANT_FORM_PLACEHOLDER,
  jobTitles: JOB_TITLES_PLACEHOLDER,
  seniorities: SENIORITIES_PLACEHOLDER,
  industries: INDUSTRIES_PLACEHOLDER,
  jobFunctions: JOB_FUNCTIONS_PLACEHOLDER,
  companySizes: COMPANY_SIZES_PLACEHOLDER,
  companies: COMPANIES_PLACEHOLDER,
  degrees: DEGREES_PLACEHOLDER,
  fieldsOfStudy: FIELDS_OF_STUDY_PLACEHOLDER,
  schools: SCHOOLS_PLACEHOLDER,
  skills: SKILLS_PLACEHOLDER,
  memberBehaviors: MEMBER_BEHAVIORS_PLACEHOLDER,
};

export const getFieldLabel = ({ field, t }) => {
  const key = FIELD_LABEL_KEYS[field];
  if (!key) return field;
  return t(key);
};

export const FIELD_KIND_SCHEDULE = "schedule";
export const FIELD_KIND_OBJECT_SUMMARY = "objectSummary";
export const FIELD_KIND_CHIPS = "chips";
export const FIELD_KIND_KEY_VALUE = "keyValue";
export const FIELD_KIND_DATE_TIME = "dateTime";
export const FIELD_KIND_SIMPLE_VALUE = "simpleValue";
export const FIELD_KIND_LINKS = "links";
export const FIELD_KIND_MEDIA_PREVIEW = "mediaPreview";
export const FIELD_KIND_ARRAY_ADD_REMOVE = "arrayAddRemove";
export const FIELD_KIND_LOGO = "logo";
export const FIELD_KIND_INSIGHT = "insight";

const FIELD_KINDS = {
  schedule: FIELD_KIND_SCHEDULE,
  productSetAudience: FIELD_KIND_OBJECT_SUMMARY,
  placements: FIELD_KIND_OBJECT_SUMMARY,
  advantageEnhances: FIELD_KIND_OBJECT_SUMMARY,
  appConfiguration: FIELD_KIND_OBJECT_SUMMARY,
  instantExperience: FIELD_KIND_OBJECT_SUMMARY,
  messageTemplate: FIELD_KIND_OBJECT_SUMMARY,
  address: FIELD_KIND_OBJECT_SUMMARY,
  productsConfiguration: FIELD_KIND_OBJECT_SUMMARY,
  biddingStrategy: FIELD_KIND_OBJECT_SUMMARY,
  instantForm: FIELD_KIND_OBJECT_SUMMARY,
  leadForm: FIELD_KIND_OBJECT_SUMMARY,

  specialAdCategories: FIELD_KIND_CHIPS,
  languages: FIELD_KIND_CHIPS,
  callToActions: FIELD_KIND_CHIPS,
  offlineEvents: FIELD_KIND_CHIPS,
  conversionActions: FIELD_KIND_CHIPS,
  jobTitles: FIELD_KIND_CHIPS,
  seniorities: FIELD_KIND_CHIPS,
  industries: FIELD_KIND_CHIPS,
  jobFunctions: FIELD_KIND_CHIPS,
  companySizes: FIELD_KIND_CHIPS,
  companies: FIELD_KIND_CHIPS,
  degrees: FIELD_KIND_CHIPS,
  fieldsOfStudy: FIELD_KIND_CHIPS,
  schools: FIELD_KIND_CHIPS,
  skills: FIELD_KIND_CHIPS,
  memberBehaviors: FIELD_KIND_CHIPS,

  utmParameters: FIELD_KIND_KEY_VALUE,

  startDate: FIELD_KIND_DATE_TIME,
  endDate: FIELD_KIND_DATE_TIME,

  deepLink: FIELD_KIND_LINKS,
  musicUrl: FIELD_KIND_LINKS,

  mediaData: FIELD_KIND_MEDIA_PREVIEW,

  estimationID: FIELD_KIND_SIMPLE_VALUE,
  minBudget: FIELD_KIND_SIMPLE_VALUE,
  maxBudget: FIELD_KIND_SIMPLE_VALUE,
  isAdvantageAudienceActive: FIELD_KIND_SIMPLE_VALUE,
  appProductPageID: FIELD_KIND_SIMPLE_VALUE,
  destinationFallBack: FIELD_KIND_SIMPLE_VALUE,
  trackingID: FIELD_KIND_SIMPLE_VALUE,
  trackingOfflineID: FIELD_KIND_SIMPLE_VALUE,
  bidGoal: FIELD_KIND_SIMPLE_VALUE,
  targetCPA: FIELD_KIND_SIMPLE_VALUE,

  logoUrl: FIELD_KIND_LOGO,
  insight: FIELD_KIND_INSIGHT,

  imageUrls: FIELD_KIND_ARRAY_ADD_REMOVE,
  logoUrls: FIELD_KIND_ARRAY_ADD_REMOVE,
  videoUrls: FIELD_KIND_ARRAY_ADD_REMOVE,
  siteLinks: FIELD_KIND_ARRAY_ADD_REMOVE,
  keywords: FIELD_KIND_ARRAY_ADD_REMOVE,
  keywordsNegative: FIELD_KIND_ARRAY_ADD_REMOVE,
  callOuts: FIELD_KIND_ARRAY_ADD_REMOVE,
  descriptions: FIELD_KIND_ARRAY_ADD_REMOVE,
  titles: FIELD_KIND_ARRAY_ADD_REMOVE,
  headlines: FIELD_KIND_ARRAY_ADD_REMOVE,
  longHeadlines: FIELD_KIND_ARRAY_ADD_REMOVE,
  searchThemes: FIELD_KIND_ARRAY_ADD_REMOVE,
  destinationUrls: FIELD_KIND_ARRAY_ADD_REMOVE,
  interests: FIELD_KIND_ARRAY_ADD_REMOVE,
  behaviors: FIELD_KIND_ARRAY_ADD_REMOVE,
  demographics: FIELD_KIND_ARRAY_ADD_REMOVE,
  locations: FIELD_KIND_ARRAY_ADD_REMOVE,
  excludedLocations: FIELD_KIND_ARRAY_ADD_REMOVE,
  customAudiences: FIELD_KIND_ARRAY_ADD_REMOVE,
  excludedCustomAudiences: FIELD_KIND_ARRAY_ADD_REMOVE,
  mediaUrls: FIELD_KIND_ARRAY_ADD_REMOVE,
};

export const getFieldKind = (field) =>
  FIELD_KINDS[field] || FIELD_KIND_SIMPLE_VALUE;

export const getDisplayText = (item) => {
  if (item == null) return "";
  if (typeof item === "string") return item;
  if (typeof item === "number" || typeof item === "boolean")
    return String(item);
  if (typeof item === "object") {
    return item.name || item.title || item.label || item.value || item.id || "";
  }
  return String(item);
};

export const normalizeArrayItems = (items) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => {
    if (typeof item === "object" && item !== null && item.value && !item.name) {
      return item.value;
    }
    return item;
  });
};

const NUMBER_CURRENCY_FIELDS = [
  "budget",
  "minBudget",
  "maxBudget",
  "dailyBudget",
  "bidGoal",
  "targetCPA",
];

export const formatValue = (value, field, t) => {
  if (
    NUMBER_CURRENCY_FIELDS.includes(field) &&
    (value == null || value === "")
  ) {
    return formatNumberForLog(0);
  }

  if (
    (field === "endDate" || field === "startDate") &&
    typeof value === "number"
  ) {
    return format(new Date(value), "dd/MM/yyyy HH:mm");
  }

  if (field === "status") {
    return t(STATUS_TRANSLATIONS[value]) || value;
  }

  if (field === "genders" && typeof value === "object" && value !== null) {
    const parts = [];
    if (value.male) parts.push(t(MALES));
    if (value.female) parts.push(t(FEMALES));
    return parts.join(", ");
  }

  if (field === "ageRange" && Array.isArray(value) && value.length === 2) {
    return `${value[0]} - ${value[1]}`;
  }

  const budgetFields = ["budget", "minBudget", "maxBudget", "dailyBudget"];
  if (
    budgetFields.includes(field) &&
    (typeof value === "number" || (value != null && !isNaN(Number(value))))
  ) {
    return formatNumberForLog(value);
  }

  if (field === "bidGoal" || field === "targetCPA") {
    const num = Number(value);
    if (!isNaN(num)) return formatNumberForLog(num);
    return String(value ?? "");
  }

  if (field === "isAdvantageAudienceActive") {
    return value ? "On" : "Off";
  }

  const num = Number(value);
  if (value != null && !isNaN(num) && typeof value !== "boolean") {
    return formatNumberForLog(num);
  }

  return value;
};

/** Max length for inline JSON before truncating (default log branch). */
const MAX_LOG_INLINE_VALUE_LENGTH = 280;

/**
 * Default log display for fields without a dedicated UI branch.
 * Runs field-specific formatting first, then:
 * - null / undefined / "" → "-"
 * - string → as-is
 * - number, boolean, bigint → String(...)
 * - object or array → JSON.stringify (truncated if very long)
 */
export const formatDefaultLogChangeDisplay = (value, field, t) => {
  const formatted = formatValue(value, field, t);

  if (formatted == null || formatted === "") {
    return "-";
  }

  if (typeof formatted === "string") {
    return formatted;
  }

  if (
    typeof formatted === "number" ||
    typeof formatted === "boolean" ||
    typeof formatted === "bigint"
  ) {
    return String(formatted);
  }

  if (typeof formatted === "object") {
    try {
      const serialized = JSON.stringify(formatted);
      if (serialized.length <= MAX_LOG_INLINE_VALUE_LENGTH) {
        return serialized;
      }
      return `${serialized.slice(0, MAX_LOG_INLINE_VALUE_LENGTH)}…`;
    } catch {
      return String(formatted);
    }
  }

  return String(formatted);
};

export const formatUtmParams = (value) => {
  if (!value || typeof value !== "string") return [];
  const parsed = parseUtmString(value);
  return Object.entries(parsed).map(([key, val]) => ({ key, value: val }));
};

/** Returns true when schedule is "always on" (no intervals, only timezone or empty). */
export const isScheduleAlwaysOn = (schedule) => {
  if (!schedule || typeof schedule !== "object") return false;
  const obj = typeof schedule === "string" ? JSON.parse(schedule) : schedule;
  return !obj?.intervals || obj.intervals.length === 0;
};

export const formatScheduleSummary = (schedule) => {
  if (!schedule || typeof schedule !== "object") return null;
  const obj = typeof schedule === "string" ? JSON.parse(schedule) : schedule;
  if (isScheduleAlwaysOn({ ...obj })) return null;
  if (!obj?.intervals?.length) return null;
  return obj;
};

export const formatObjectSummary = (value, field, t) => {
  if (!value || typeof value !== "object") return String(value ?? "");

  switch (field) {
    case "placements":
      return formatPlacementsForLog(value, t);

    case "productSetAudience": {
      const parts = [];
      if (value.productSetID) parts.push(`Product Set: ${value.productSetID}`);
      const inclCount = value.inclusions?.length || 0;
      const exclCount = value.exclusions?.length || 0;
      if (inclCount > 0) parts.push(`${inclCount} inclusion(s)`);
      if (exclCount > 0) parts.push(`${exclCount} exclusion(s)`);
      return parts.join(" | ") || "Prospecting";
    }

    case "advantageEnhances": {
      let ids = [];
      if (Array.isArray(value)) {
        ids = value.filter((v) => typeof v === "string");
      } else if (typeof value === "string") {
        ids = value
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
      } else if (value && typeof value === "object") {
        ids = Object.entries(value)
          .filter(([, v]) => v === true)
          .map(([k]) => k);
      }
      const labels = ids.map((id) => {
        const key = ADVANTAGE_ENHANCES_ID_TO_LABEL[id];
        return key && t ? t(key) : id;
      });
      return labels.length > 0 ? labels.join(", ") : "None";
    }

    case "appConfiguration": {
      const parts = [];
      if (value.appID) parts.push(`App: ${value.appID}`);
      if (value.androidDeepLink)
        parts.push(`Android: ${value.androidDeepLink}`);
      if (value.iosDeepLink) parts.push(`iOS: ${value.iosDeepLink}`);
      return parts.join(" | ") || "";
    }

    case "instantExperience":
      return value.name || value.id || "";

    case "instantForm":
      return value.name || value.id || "";

    case "leadForm":
      return value.name || value.id || "";

    case "messageTemplate": {
      const parts = [];
      if (value.greeting) parts.push(value.greeting);
      if (value.customerTypeMessage) parts.push(value.customerTypeMessage);
      if (value.customerTexts?.length > 0) parts.push(value.customerTexts[0]);
      return parts.join(" | ") || "";
    }

    case "address":
      return value.name
        ? `${value.name} (${value.lat}, ${value.lng})`
        : `${value.lat}, ${value.lng}`;

    case "biddingStrategy": {
      const labelKey = GOOGLE_BIDDING_STRATEGY_LABELS[value.type];
      const typeLabel = labelKey && t ? t(labelKey) : value.type || "";
      if (!value.value && value.value !== 0) return typeLabel;
      return `${typeLabel}: ${formatNumberForLog(value.value)}`;
    }

    case "productsConfiguration": {
      if (value.productSetID)
        return `${value.type || ""} (${value.productSetID})`;
      const typeKey = value.type === "allProducts" ? ALL_PRODUCTS : "";
      const typeLabel = t ? t(typeKey) : value.type || "";
      if (value.type === "allProducts" || !value.children?.length)
        return typeLabel;
      const subOpt = SUBDIVISION_OPTIONS_GOOGLE.find(
        (s) => s.value === value.subdivision
      );
      const subLabel = subOpt && t ? t(subOpt.label) : value.subdivision || "";
      const labels = [];
      const opts = subOpt?.options || [];
      for (const child of value.children) {
        const found = opts.find((o) => o.value === child);
        labels.push(found && t ? t(found.label) : child);
      }
      const catPart =
        labels.length > 0 ? `${subLabel}: ${labels.join(", ")}` : subLabel;
      return catPart;
    }

    default:
      return JSON.stringify(value);
  }
};

export const IMAGE_FIELDS = ["imageUrls", "logoUrl", "logoUrls"];
export const MEDIA_URL_FIELDS = ["mediaUrls"];
export const SITE_LINK_FIELDS = ["siteLinks"];
export const TEXT_LIST_FIELDS = [
  "keywords",
  "keywordsNegative",
  "callOuts",
  "descriptions",
  "titles",
  "headlines",
  "longHeadlines",
  "searchThemes",
  "destinationUrls",
  "videoUrls",
];
export const CHIPS_ARRAY_FIELDS = [
  "interests",
  "behaviors",
  "demographics",
  "locations",
  "excludedLocations",
  "customAudiences",
  "excludedCustomAudiences",
];

export { getLanguageLabel } from "../../../../../utils/catalogs/languageOptions";
